import { useState } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";
import "../ResolutionTools/ResolutionTools.css";
import "./ReplaceExpression.css";

function ReplaceExpression({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("ReplaceExpressionGroupVisibility");
  const [find, setFind] = useState("");
  const [replace, setReplace] = useState("");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i className="fa-sharp fa-regular fa-arrows-rotate"></i>
          <div />
        </div>
        <div className="button-card__title">Replace Expression</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group replace-expression__wrapper ${
          isVisible ? "" : "render-group--hidden"
        }`}
      >
        <div className="replace-expression__inputs">
          <div className="replace-expression__field">
            <span className="render-group__dropdown-text">Find</span>
            <textarea
              value={find}
              onChange={(e) => setFind(e.target.value)}
              className="rename__input"
              onClick={(e) => e.stopPropagation()}
              rows={5}
            />
          </div>
          <div className="replace-expression__field">
            <span className="render-group__dropdown-text">Replace</span>
            <textarea
              value={replace}
              onChange={(e) => setReplace(e.target.value)}
              className="rename__input"
              onClick={(e) => e.stopPropagation()}
              rows={5}
            />
          </div>
        </div>
        <div className="resolution-tools replace-expression__actions">
          <div
            onClick={() =>
              handleClick("replaceExpression", { find, replace, type: "layer" })
            }
            className="resolution-tools__button"
          >
            <i className="fa-light fa-layer-group"></i>
            <span>Selected Layers</span>
          </div>
          <div
            onClick={() =>
              handleClick("replaceExpression", { find, replace, type: "comp" })
            }
            className="resolution-tools__button"
          >
            <i className="fa-solid fa-image-polaroid"></i>
            <span>Active Comp</span>
          </div>
          <div
            onClick={() =>
              handleClick("replaceExpression", { find, replace, type: "selected comp" })
            }
            className="resolution-tools__button"
          >
            <i className="fa-solid fa-images"></i>
            <span>Selected Comps</span>
          </div>
          <div
            onClick={() =>
              handleClick("replaceExpression", { find, replace, type: "project" })
            }
            className="resolution-tools__button"
          >
            <i className="fa-regular fa-photo-film"></i>
            <span>Project</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReplaceExpression;
